"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPasswordInput = exports.StyledPasswordIndicator = exports.StyledPasswordHeader = exports.StyledPasswordContainer = exports.StyledModalParagraph = exports.StyledModalHintListItem = exports.StyledModal = exports.StyledListItemText = exports.StyledListItemIcon = exports.StyledListItem = exports.StyledList = exports.StyledLink = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconElement = _interopRequireDefault(require("../../fuse-icon-element/src/icon-element"));
var _input = require("../../fuse-input/src/input");
var _link = require("../../fuse-link/src/link");
var _modal = require("../../fuse-modal/src/modal");
var _passwordIndicator = require("../../fuse-password-indicator/src/password-indicator");
var _typography = require("../../fuse-typography-element/src/typography");
var _config = _interopRequireDefault(require("./config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var componentName = _config["default"].componentName;
var StyledPasswordContainer = exports.StyledPasswordContainer = _styledComponents["default"].div.attrs({
  className: "".concat(componentName, "__password-container"),
  'data-testid': "".concat(componentName, "-password-container-test-id")
}).withConfig({
  displayName: "styled-password__StyledPasswordContainer",
  componentId: "sc-1w1x5w7-0"
})([""]);
var StyledPasswordIndicator = exports.StyledPasswordIndicator = (0, _styledComponents["default"])(_passwordIndicator.PasswordIndicator).attrs({
  className: "".concat(componentName, "__password-indicator"),
  'data-testid': "".concat(componentName, "-password-indicator-test-id")
}).withConfig({
  displayName: "styled-password__StyledPasswordIndicator",
  componentId: "sc-1w1x5w7-1"
})([".fuse-password-indicator__indicator:last-of-type{margin-right:0;}margin-bottom:var(--spacing-global-space4);"]);
var StyledList = exports.StyledList = _styledComponents["default"].ul.attrs({
  className: "".concat(componentName, "__password-requirements-list"),
  'data-testid': "".concat(componentName, "-password-requirements-list-test-id")
}).withConfig({
  displayName: "styled-password__StyledList",
  componentId: "sc-1w1x5w7-2"
})(["margin-bottom:var(--spacing-global-space4);"]);
var StyledListItem = exports.StyledListItem = _styledComponents["default"].li.attrs({
  className: "".concat(componentName, "__password-requirements-list-item"),
  'data-testid': "".concat(componentName, "-password-requirements-list-item-test-id")
}).withConfig({
  displayName: "styled-password__StyledListItem",
  componentId: "sc-1w1x5w7-3"
})(["display:flex;margin-bottom:var(--spacing-global-space2);gap:var(--spacing-global-space3);"]);
var StyledListItemIcon = exports.StyledListItemIcon = (0, _styledComponents["default"])(_iconElement["default"]).attrs({
  className: "".concat(componentName, "__password-requirements-list-item-icon"),
  'data-testid': "".concat(componentName, "-password-requirements-list-item-icon-test-id")
}).withConfig({
  displayName: "styled-password__StyledListItemIcon",
  componentId: "sc-1w1x5w7-4"
})(["flex-shrink:0;"]);
var StyledListItemText = exports.StyledListItemText = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: "".concat(componentName, "__password-requirements-list-item-text"),
  'data-testid': "".concat(componentName, "-password-requirements-list-item-text-test-id")
}).withConfig({
  displayName: "styled-password__StyledListItemText",
  componentId: "sc-1w1x5w7-5"
})(["margin-bottom:0px;"]);
var StyledPasswordHeader = exports.StyledPasswordHeader = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: "".concat(componentName, "__password-header"),
  'data-testid': "".concat(componentName, "-password-header-test-id")
}).withConfig({
  displayName: "styled-password__StyledPasswordHeader",
  componentId: "sc-1w1x5w7-6"
})(["margin-bottom:var(--spacing-global-space4);"]);
var StyledPasswordInput = exports.StyledPasswordInput = (0, _styledComponents["default"])(_input.Input).attrs({
  className: "".concat(componentName, "__password-input"),
  'data-testid': "".concat(componentName, "-password-input-test-id")
}).withConfig({
  displayName: "styled-password__StyledPasswordInput",
  componentId: "sc-1w1x5w7-7"
})(["margin-bottom:var(--spacing-global-space4);& p{margin-bottom:var(--spacing-global-space4);}"]);
var StyledLink = exports.StyledLink = (0, _styledComponents["default"])(_link.Link).attrs({
  className: "".concat(componentName, "__password-link"),
  'data-testid': "".concat(componentName, "-link-test-id")
}).withConfig({
  displayName: "styled-password__StyledLink",
  componentId: "sc-1w1x5w7-8"
})(["margin-top:var(--spacing-global-space2);"]);
var StyledModal = exports.StyledModal = (0, _styledComponents["default"])(_modal.Modal).attrs({
  className: "".concat(componentName, "__password-modal"),
  'data-testid': "".concat(componentName, "-password-modal-test-id")
}).withConfig({
  displayName: "styled-password__StyledModal",
  componentId: "sc-1w1x5w7-9"
})(["z-index:1;"]);
var StyledModalParagraph = exports.StyledModalParagraph = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: "".concat(componentName, "__password-modal-paragraph"),
  'data-testid': "".concat(componentName, "-password-modal-paragraph-test-id")
}).withConfig({
  displayName: "styled-password__StyledModalParagraph",
  componentId: "sc-1w1x5w7-10"
})(["&&{vertical-align:middle;}"]);
var StyledModalHintListItem = exports.StyledModalHintListItem = _styledComponents["default"].li.attrs({
  className: "".concat(componentName, "__password--modal-hintlist-item"),
  'data-testid': "".concat(componentName, "-password-requirements-list-test-id")
}).withConfig({
  displayName: "styled-password__StyledModalHintListItem",
  componentId: "sc-1w1x5w7-11"
})(["margin-bottom:var(--spacing-global-space4);"]);